// WELLF contact page:
//  1. Pre-select the "reason" dropdown from a ?reason= query param, so the
//     footer Delivery / Wholesale links land on the form with the right topic.
//  2. Inline validation shown as each field is left (blur/change), not only on
//     submit: required fields, a valid email, a UK / international phone, and a
//     message of at least 50 characters. Native validation is turned off so
//     these custom messages are the only ones shown; the `required` / type /
//     minlength attributes remain as a no-JS fallback.

(function () {
  const form = document.querySelector('.wcontact__form');
  if (!form) return;
  form.setAttribute('novalidate', 'novalidate');

  // ── Reason pre-select ─────────────────────────────────────────────────
  const reason = new URLSearchParams(window.location.search).get('reason');
  if (reason) {
    const map = {
      delivery: 'Order or delivery', order: 'Order or delivery',
      wholesale: 'Wholesale & stockists', stockists: 'Wholesale & stockists',
      club: 'Club Member', member: 'Club Member',
      press: 'Press', partnerships: 'Partnerships', general: 'General question',
    };
    const target = map[reason.trim().toLowerCase()];
    const select = form.querySelector('[data-wellf-reason]');
    if (target && select) {
      const option = Array.from(select.options).find(
        (o) => o.value === target || o.textContent.trim() === target
      );
      if (option) select.value = option.value || option.textContent.trim();
    }
  }

  // ── Validation rules ──────────────────────────────────────────────────
  const phoneMsg = 'Enter a valid phone number.';
  const phoneOk = (v) => {
    const c = v.replace(/[\s().\-]/g, '');
    return /^0\d{10}$/.test(c) || /^\+\d{8,15}$/.test(c) || /^00\d{8,15}$/.test(c);
  };
  const emailOk = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);

  const rules = {
    'contact[first_name]': { req: 'Enter your first name.' },
    'contact[last_name]': { req: 'Enter your last name.' },
    'contact[email]': { req: 'Enter your email address.', test: emailOk, msg: 'Enter a valid email address.' },
    'contact[phone]': { req: 'Enter your phone number.', test: phoneOk, msg: phoneMsg },
    'contact[reason]': { req: 'Choose a topic.' },
    'contact[body]': { req: 'Tell us what you need.', test: (v) => v.trim().length >= 50, msg: 'Please enter at least 50 characters.' },
  };

  const fieldOf = (name) => form.querySelector('[name="' + name + '"]');

  const messageFor = (name, value) => {
    const rule = rules[name];
    if (!rule) return '';
    const v = (value == null ? '' : value).trim();
    if (!v) return rule.req || 'This field is required.';
    if (rule.test && !rule.test(v)) return rule.msg;
    return '';
  };

  // Paints the error state for one field. Returns true if the field is valid.
  const paint = (name) => {
    const field = fieldOf(name);
    if (!field) return true;
    const wrap = field.closest('.wcf');
    const errEl = wrap && wrap.querySelector('[data-error]');
    const msg = messageFor(name, field.value);
    if (wrap) wrap.classList.toggle('is-invalid', Boolean(msg));
    if (errEl) errEl.textContent = msg;
    return !msg;
  };

  Object.keys(rules).forEach((name) => {
    const field = fieldOf(name);
    if (!field) return;
    const leaveEvent = field.tagName === 'SELECT' ? 'change' : 'blur';
    field.addEventListener(leaveEvent, () => paint(name));
    // Once a field is showing an error, re-check as the user fixes it.
    field.addEventListener('input', () => {
      const wrap = field.closest('.wcf');
      if (wrap && wrap.classList.contains('is-invalid')) paint(name);
    });
  });

  form.addEventListener('submit', (event) => {
    let firstInvalid = null;
    Object.keys(rules).forEach((name) => {
      if (!paint(name) && !firstInvalid) firstInvalid = fieldOf(name);
    });
    if (firstInvalid) {
      event.preventDefault();
      firstInvalid.focus();
    }
  });
})();
